/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LevelContentItemView.vue?vue&type=template&id=58e2543f&scoped=true"
import script from "./LevelContentItemView.vue?vue&type=script&lang=js"
export * from "./LevelContentItemView.vue?vue&type=script&lang=js"
import style0 from "./LevelContentItemView.vue?vue&type=style&index=0&id=58e2543f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e2543f",
  null
  
)

export default component.exports